import React from 'react';

import cusheader from '../../assets/cusheader.jpg';
import cuskey1 from '../../assets/cus1.jpg';
import cuskey2 from '../../assets/cus2.jpeg';
import cuskey3 from '../../assets/cus3.jpg';
import ServiceTech from '../../component/servicetech'
const CustomerSoftDev = () => {
  const data =  {
    "headerimg": cusheader,
    "key1img": cuskey1,
    "key2img": cuskey2,
    "key3img": cuskey3,
    "maintitle":"Our dedication to achievement is fueled by our core values......",
    "mainsub":"Innovating IT, Empowering Business.",

    "title":"Custom Software Development",
    "subtext":"Custom Software Development is a tailored approach to building software solutions that are designed specifically to meet the unique needs and challenges of a business. For IT service-based companies, custom software development offers the ability to design, develop, and deploy software that aligns precisely with your clients' goals, processes, and industry-specific requirements.",
   "choose1": "Our team has extensive experience in developing custom software tailored specifically for IT companies across various industries. We deeply understand your unique requirements and leverage our technical expertise to deliver solutions that effectively drive results and enhance your operational efficiency while addressing the specific challenges faced by your business.",

    "choose2": "Custom software development is crucial for businesses aiming to transform operations, enhance efficiency, and provide unique services tailored to specific industry demands. Whether you’re automating workflows, integrating systems, or creating entirely new platforms, custom software delivers the flexibility and performance your business needs to succeed in today’s competitive landscape.",

    "choose3": "Custom software development is essential for businesses seeking to transform operations, boost efficiency, and provide unique services tailored to industry demands. Whether you are automating workflows, integrating systems, or building new platforms, custom software delivers the flexibility and performance necessary for your business to succeed in an ever-evolving marketplace.",
    "key1":"Personalized Solutions",
    "key2":"Scalability",
    "key3":"Enhanced Security",
    "key4":"Competitive Advantage",
    "key5":"Integration and Flexibility",
   
    "text1":"Unlike off-the-shelf products, custom software is created with a company's specific business objectives in mind. This ensures that the software integrates seamlessly into existing workflows, improves efficiency, and enhances productivity.",
    "text2":"As your clients' businesses grow, their software needs evolve. Custom solutions are built to be scalable, allowing for future enhancements, feature updates, and integrations as their needs change.",
    "text3":"With custom software, IT companies can implement security measures that are tailored to the specific needs of the client, ensuring stronger protection against cyber threats compared to generic software solutions.",
    "text4":"Custom software allows businesses to stand out by providing unique functionalities that cannot be found in standard software packages. This can create new opportunities and help differentiate businesses from competitors.",
    "text5":"Custom software can be designed to integrate with existing systems, creating a cohesive environment where different software tools communicate effectively, reducing operational silos",
    "text6":"With our expertise, organizations can rethink, re-engineer, and streamline their core processes for improved performance."




}

  return (

 

  <>
    <ServiceTech values={data} />
  </>

    
 
)
};

export default CustomerSoftDev;
